import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { PosteReq } from "../data/http/requests/poste.req";
import { PosteRes } from "../data/http/responses/poste.res";
import { HttpClient } from "@angular/common/http";
import { AppService } from "../core/app.service";
import { env } from "../../env/env";

@Injectable({
    providedIn: 'root'
})
export class PosteService extends AbstractService<PosteReq, PosteRes> {
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}poste`, http, appService); 
    }
}